module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-02-6418fafff333d58a5479024ea24541e4.svg";